import { Modal } from '@mantine/core'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import PointOfContactModal from '@/components/make-booking/checkout/modals/PointOfContactModal'

export const Route = createFileRoute('/make-booking/$id/checkout/poc')({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  return (
    <Modal
      opened
      onClose={() => router.history.back()}
      title="Point of Contact"
      centered
      classNames={{
        title: '!text-[22px] !font-bold',
        content: '!p-5',
      }}
      size="xl"
    >
      <PointOfContactModal onClose={() => router.history.back()} />
    </Modal>
  )
}
